import {
  GET_CHALLANS,
  GET_CHALLANS_SUCCESS,
  GET_CHALLANS_FAIL,
  GET_CHALLAN_DETAILS,
  GET_CHALLAN_DETAILS_SUCCESS,
  GET_CHALLAN_DETAILS_FAIL,
  CREATE_CHALLAN,
  CREATE_CHALLAN_SUCCESS,
  CREATE_CHALLAN_FAIL,
  UPDATE_CHALLAN,
  UPDATE_CHALLAN_SUCCESS,
  UPDATE_CHALLAN_FAIL,
  RESET_CHALLAN_STATE,
  CHECK_CHALLAN_NUMBER,
  CHECK_CHALLAN_NUMBER_FAIL,
  CHECK_CHALLAN_NUMBER_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  challans: {
    challans: [],
    total: "",
    page: "",
  },
  challanDetails: {},
  createChallanData: {},
  error: {},
  loading: false,
  challanNumber: {},
}

const Challan = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Challan - This line cannot be edited or removed
    case GET_CHALLANS:
    case GET_CHALLAN_DETAILS:
    case CREATE_CHALLAN:
    case UPDATE_CHALLAN:
    case CHECK_CHALLAN_NUMBER:
      return {
        ...state,
        loading: true,
      }

    case GET_CHALLANS_FAIL:
    case GET_CHALLAN_DETAILS_FAIL:
    case UPDATE_CHALLAN_FAIL:
    case CREATE_CHALLAN_FAIL:
    case CHECK_CHALLAN_NUMBER_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_CHALLANS_SUCCESS:
      return {
        ...state,
        challans: action.payload,
        error: {},
        loading: false,
      }

    case GET_CHALLAN_DETAILS_SUCCESS:
      return {
        ...state,
        challanDetails: action.payload,
        error: {},
        loading: false,
      }

    case CREATE_CHALLAN_SUCCESS:
      return {
        ...state,
        challans: {
          ...state.challans,
          challans: [...state.challans.challans, action.payload],
          total: state.challans.total + 1,
        },
        challanDetails: action.payload,
        createChallanData: action.payload,
        error: {},
        loading: false,
      }

    case UPDATE_CHALLAN_SUCCESS:
      return {
        ...state,
        // challans: {
        //   ...state.challans,
        //   challans: state.challans.challans.map(challan =>
        //     challan._id === action.payload._id
        //       ? { ...challan, ...action.payload }
        //       : challan
        //   ),
        // },
        // challanDetails: action.payload,
        loading: false,
        error: {},
      }

    case CHECK_CHALLAN_NUMBER_SUCCESS:
      return {
        ...state,
        challanNumber: action.payload,
        error: {},
        loading: false,
      }
    case RESET_CHALLAN_STATE:
      return {
        ...state,
        createChallanData: {},
        challanDetails: {},
      }
    default:
      return state
  }
}

export default Challan
